import {ReactElement} from "react";
import {styled} from "styled-components";

import {quicksandSemiBold} from "@/GlobalStyle";
import {Pagination as PaginationType} from "@/ts/pagination";

const PaginationStyled = styled.div`
  display: flex;
  gap: 40px;
  margin: 15px auto;
  justify-content: center;
`;

const PaginationAllButton = styled.div`
  display: flex;
  gap: 15px;
`;

const PaginationButton = styled.div<{$isActive: boolean}>`
  width: 30px;
  height: 30px;
  border-radius: 15px;
  background-color: ${({$isActive, theme}) => {
    return $isActive ? theme.colors.mediumSecondary : "white";
  }};
  text-align: center;
  line-height: 30px;
  color: ${({$isActive, theme}) => {
    return $isActive ? "white" : theme.colors.mediumSecondary;
  }};
  ${quicksandSemiBold}
  &:hover {
    cursor: pointer;
    outline: solid 2px ${({theme}) => theme.colors.mediumSecondary};
  }
`;

const PaginationLink = styled.div`
  height: 30px;
  padding: 0 20px;
  border-radius: 15px;
  background-color: white;
  text-align: center;
  line-height: 30px;
  color: ${({theme}) => theme.colors.mediumSecondary};
  ${quicksandSemiBold}
  &:hover {
    cursor: pointer;
    outline: solid 2px ${({theme}) => theme.colors.mediumSecondary};
  }
`;

export function Pagination({
  pagination,
  onChangePagination,
  ...props
}: {
  pagination: PaginationType;
  onChangePagination: (value: number) => void;
}): ReactElement {
  const ButtonPagginate = (number: number): ReactElement => {
    return (
      <PaginationButton
        $isActive={number.toString() === pagination?.current.toString()}
        key={number}
        onClick={() => {
          onChangePagination(number);
        }}>
        {number}
      </PaginationButton>
    );
  };
  const allButton = [];

  const endpagination = Math.min(pagination?.last, pagination?.current + 3);
  const startPaggintaion = Math.max(1, pagination?.current - 3);

  const goFirstPage: ReactElement | null =
    startPaggintaion > 1 ? (
      <PaginationLink
        onClick={() => {
          onChangePagination(1);
        }}>
        Première page
      </PaginationLink>
    ) : null;
  const goLastPage =
    endpagination < pagination?.last ? (
      <PaginationLink
        onClick={() => {
          onChangePagination(pagination?.last);
        }}>
        Dernière page
      </PaginationLink>
    ) : null;
  for (let index = startPaggintaion; index <= endpagination; index++) {
    allButton.push(ButtonPagginate(index));
  }

  return (
    <PaginationStyled {...props}>
      <PaginationAllButton>
        {goFirstPage}
        {allButton}
        {goLastPage}
      </PaginationAllButton>
    </PaginationStyled>
  );
}
